export default "__VITE_ASSET__V9NRmjcK__"